/** In-app path only. Rejects external URLs and the login page. */
export function safeNextPath(value) {
  const raw = String(value || "").trim();
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return "";
  if (
    raw === "/login" ||
    raw.startsWith("/login?") ||
    raw.startsWith("/page-") ||
    raw.startsWith("/reset-password") ||
    raw.startsWith("/activate-account")
  ) {
    return "";
  }
  return raw;
}
